import { useCallback, useMemo, useState } from "react";
import FALLBACKLogo from "../../../assets/svg/assets/FALLBACK.svg";
import { AssetResponse } from "../../../utils/asset";
import { getAssetLogo, getAssetShortName } from "../../../utils/asset/assets";
import { getAssetFromSymbol } from "../../../utils/instruments";
import { TickerLogoWrapper } from "./style";

interface ITickerLogoProps {
  /** Asset symbol (e.g. "BTC", "ETH"). Takes precedence over instrumentName. */
  asset?: AssetResponse | string;
  /** Full instrument name (e.g. "BTC-PERP", "ETH-USDC"). Base asset is parsed from this. */
  instrumentName?: string;
  /** Pixel size of the logo square. Default 32. */
  size?: number;
  /** Render as circle (default) or rounded square. */
  rounded?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

function TickerLogo({
  asset,
  instrumentName,
  size = 32,
  rounded = true,
  className,
  style,
}: ITickerLogoProps) {
  const resolvedAsset = useMemo(() => {
    if (asset) return asset as AssetResponse;
    if (instrumentName) return getAssetFromSymbol(instrumentName);
    return undefined;
  }, [asset, instrumentName]);

  const src = useMemo(
    () => getAssetLogo(resolvedAsset) || FALLBACKLogo,
    [resolvedAsset]
  );

  const [didError, setDidError] = useState(false);
  const handleError = useCallback(() => setDidError(true), []);

  const altLabel =
    (getAssetShortName(resolvedAsset) as string) ||
    (resolvedAsset as string) ||
    "asset";

  return (
    <TickerLogoWrapper
      $size={size}
      rounded={rounded}
      className={className}
      style={style}
    >
      <img
        src={didError ? FALLBACKLogo : src}
        alt={altLabel}
        onError={handleError}
        loading="lazy"
      />
    </TickerLogoWrapper>
  );
}

export default TickerLogo;
